import { UserEnum } from "../../types/userEnum";

const useUserEnumLogic = () => {
  const defaultUserEnum: UserEnum = {
    _id: "",
    _rev: "",
    _key: "",
    values: [],
    name: "",
    notes: "",
    internal_notes: "",
  };

  const getDisplayName = (userEnum?: UserEnum | null): string =>
    `UserEnum${userEnum?.name ? `: ${userEnum.name}` : ""}`;

  return {
    defaultUserEnum,
    getDisplayName,
  };
};

export default useUserEnumLogic;
